import { keyframes } from '@emotion/react';

export const appear = keyframes`
  0% {
    background-color: transparent;
    transform: scale(0);
  }
  100% {
    background-color: var(--outline);
    transform: scale(1);
  }
`;

export const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
`;
